import { useMediaQuery } from "@mui/material";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import GoogleTranslationComponent from "../googleTranslate/GoogleTranslationComponent";
import googleIcon from "./images/google_icon.svg";
import languageIcon from "./images/languageIcon.svg";
import tripAdvisorIcon from "./images/tripadvisor_logo.svg";
import starIcon from "@/assets/images/icons/starIcon.svg";
import veeIcon from "@/assets/images/icons/veeIcon.svg";
import { AbsoluteDiv, CustomDiv, InlineDiv } from "@/common/divs";
import {
  AlmostBoldText,
  LightText,
  LightTextSpan,
  SemiBoldText,
} from "@/common/texts";
import { ActivityDetailGeoSearch } from "@/model";
import { NEUTRO_TITLES_COLOR } from "@/utils/constants";
import { getSubcategoryIconProdEnv } from "@/utils/subcategories";

const CustomNewCard: React.FC<{
  element: ActivityDetailGeoSearch;
  activityLink: string;
}> = ({ element, activityLink }) => {
  const isMobile = useMediaQuery("(max-width:450px)");
  const { t } = useTranslation();
  return (
    <a href={activityLink} target="_blank" rel="noreferrer">
      <CustomDiv
        width={isMobile ? "350px" : "420px"}
        height={isMobile ? "410px" : "470px"}
        className="div-activity"
      >
        <CustomDiv
          height={isMobile ? "180px" : "230px"}
          style={{
            position: "relative",
          }}
        >
          <div
            className="image-div"
            style={{
              backgroundImage:
                element.images ?
                  "linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8)), url(" +
                  element.images[0].link +
                  ")"
                : "",
            }}
          />

          <InlineDiv
            style={{
              justifyContent: "space-between",
              maxWidth: isMobile ? "200px" : "300px",
              marginTop: isMobile ? "5px" : "15px",
              marginLeft: "-10px",
            }}
          >
            <InlineDiv marginX="10px">
              {element.fh_tripadvisor_rating ?
                element.fh_tripadvisor_rating > 0 ?
                  <InlineDiv
                    width="80px"
                    style={{
                      justifyContent: "space-evenly",
                      background: "white",
                      marginLeft: "10px",
                      borderRadius: "16px",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      style={{ marginTop: "1px" }}
                      src={tripAdvisorIcon}
                      alt="tripAdvisor"
                      width={25}
                      height={25}
                    />
                    <AlmostBoldText
                      style={{ fontWeight: "400", color: "black" }}
                    >
                      {element.fh_tripadvisor_rating}
                    </AlmostBoldText>
                    <Image
                      src={starIcon}
                      alt="star"
                      width={22}
                      height={22}
                      style={{ marginTop: "1px" }}
                    />
                  </InlineDiv>
                : null
              : null}
              {element.fh_google_rating ?
                element.fh_google_rating > 0 ?
                  <InlineDiv
                    width="80px"
                    style={{
                      justifyContent: "space-evenly",
                      background: "white",
                      marginLeft: "10px",
                      borderRadius: "16px",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      src={googleIcon}
                      alt="google"
                      width={24}
                      height={24}
                      style={{
                        maxHeight: "24px",
                        maxWidth: "24px",
                        marginTop: "0.5px",
                      }}
                    />
                    <AlmostBoldText
                      style={{
                        fontWeight: "400",
                        color: "black",
                        lineHeight: "0px",
                      }}
                    >
                      {element.fh_google_rating}
                    </AlmostBoldText>
                    <Image
                      src={starIcon}
                      alt="star"
                      width={22}
                      height={22}
                      style={{ marginTop: "1px" }}
                    />
                  </InlineDiv>
                : null
              : null}
              {element.rating ?
                element.rating > 0 ?
                  <InlineDiv
                    width="80px"
                    style={{
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      src={veeIcon}
                      alt="tripAdvisor"
                      width={29}
                      height={29}
                      style={{ marginTop: "1px" }}
                    />
                    <AlmostBoldText
                      style={{ fontWeight: "400", color: "white" }}
                    >
                      {element.rating}
                    </AlmostBoldText>
                    <Image src={starIcon} alt="star" width={22} height={22} />
                  </InlineDiv>
                : null
              : null}
            </InlineDiv>
          </InlineDiv>
        </CustomDiv>
        <CustomDiv
          paddingX={isMobile ? "5px" : "16px"}
          paddingY={isMobile ? "5px" : "16px"}
          style={{
            flexGrow: 1,
            borderBottomLeftRadius: "16px",
            borderBottomRightRadius: "16px",
          }}
          background={NEUTRO_TITLES_COLOR}
        >
          <AlmostBoldText
            className="overflowOnTwoLines"
            color="#ffffff"
            fontSize="18px"
            style={{
              textAlign: "left",
              paddingBottom: "0px",
              minHeight: "54px",
            }}
          >
            <GoogleTranslationComponent text={element.name} />
          </AlmostBoldText>
          <InlineDiv
            style={{
              gap: "20px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <InlineDiv style={{ gap: "5px" }}>
              <img
                alt="subcaegory_icon"
                width={25}
                src={getSubcategoryIconProdEnv(
                  element.category.id,
                  element.subcategory?.id ?? 0,
                )}
              />
              <LightText fontSize="14px" color="#ffffff">
                <GoogleTranslationComponent
                  text={element.subcategory?.name ?? ""}
                />
              </LightText>
            </InlineDiv>
            <InlineDiv style={{ gap: "5px" }}>
              <img
                style={{ width: "27px", height: "27px" }}
                alt="subcaegory_icon"
                width={25}
                src={languageIcon.src}
              />
              <LightText
                fontSize="14px"
                className="language-text"
                color="#ffffff"
              >
                {element.languages.map((language, i) => {
                  if (i == element.languages.length - 1) {
                    return language.name;
                  }
                  return language.name + ", ";
                })}
              </LightText>
            </InlineDiv>
          </InlineDiv>
          <SemiBoldText
            fontSize="14px"
            className={isMobile ? "overflowOnTwoLines" : "overflowOnThreeLines"}
            style={{
              maxHeight: "100px",
              minHeight: "63px",
              color: "white",
            }}
          >
            <GoogleTranslationComponent
              text={element.description.replace(/[#*]/g, "")}
            />
          </SemiBoldText>
          <InlineDiv
            style={{
              marginTop: "10px",
              justifyContent: "space-between",
            }}
          >
            <LightTextSpan
              style={{ fontWeight: "500" }}
              fontSize="20px"
              color="#ffffff"
            >
              {t("activity.from")}{" "}
              <LightTextSpan
                style={{ fontWeight: "500" }}
                fontSize="20px"
                color="#ffcc00"
              >
                {element.priceWithTaxFormatted} {t("home.price_per_person")}
              </LightTextSpan>
            </LightTextSpan>
            <AbsoluteDiv right="0">
              <InlineDiv style={{ marginTop: "5px" }}>
                {element.manualDuration ?
                  <SemiBoldText color="#FFFFFF">
                    {element.manualDuration}
                  </SemiBoldText>
                : null}
              </InlineDiv>
            </AbsoluteDiv>
          </InlineDiv>
        </CustomDiv>
      </CustomDiv>
    </a>
  );
};

export default CustomNewCard;
